<template>
    <div class=" grid gap-y-3">
        <!-- admin Proxy Stock renders this same page with `admin`, so the two never drift apart. On the
             builds that sell for a customer from there (global / proxygo) it adds a customer picker and
             the admin purchase window; elsewhere it is a view of exactly what customers see -->
        <div class="w-full md:w-1/3 lg:w-1/5 py-2" v-if="admin && adminCanBuy">
            Customer: <span>$ {{ CustomersWithBalance.find((element) => element.email === customer)?.balance || 0 }}</span>
            <v-combobox v-model="customer" :items="customers" placeholder="Select" rounded="0"
                variant="outlined" style="outline: none;" density="compact" :hide-no-data="false">
                <template v-slot:no-data>
                    <v-list-item density>
                        <v-list-item-title density="compact" variant="disabled">
                            <p class="text-sm text-gray-600 text-center">Not found</p>
                        </v-list-item-title>
                    </v-list-item>
                </template>
            </v-combobox>
        </div>
        <div>
            <div class = "flex items-center">
                <p class="font-bold py-2">Country</p>
                <div class="w-full" v-if="!admin && (name === 'global' || name === 'proxygo')">
                    <v-btn 
                        class="btn btn-primary btn-sm float-end"
                        :disabled="!selectedDetails.country"
                        data-bs-toggle="modal"
                        data-bs-target="#newLocationModal"
                    >
                        Request New Location
                    </v-btn>
                    <v-btn 
                        class="btn btn-primary btn-sm float-end mr-2"
                        :disabled="!(selectedDetails.country && selectedDetails.isp && selectedDetails.city)"
                        data-bs-toggle="modal"
                        data-bs-target="#newStockModal"
                    >
                        Request New Stock
                    </v-btn>
                </div>
            </div>
            <div class="overflow-hidden bg-white rounded-0 border-0 p-20">
                <div v-for="country in countryList" v-bind:key="country"
                    @click="selectCountry(country.name, country.proxy_count)" class="cursor-pointer float-left text-black"
                    rounded="0">
                    <div class=" justify-between items-center p-3">
                        <div class="relative rounded  shadow-md   hover:scale-110  duration-500  border border-black"
                            :class="selectedDetails.country === country.name ? 'scale-110 shadow-blue-500' : selectedDetails.country ? ' contrast-75' : ''">
                            <img :src="country.iconurl" class="relative rounded" width="120" height="100" />
                            <span
                                class="position-absolute z-10 start-100 text-[16px] min-w-[30px] top-0 translate-middle badge rounded-pill flex items-center justify-center aspect-square"
                                :class="countryAvailableTotal(country) > 0 ? 'bg-success' : 'bg-danger'">
                                {{ countryAvailableTotal(country) }}
                            </span>
                            <div
                                class="w-full flex flex-col px-2 absolute bottom-0 rounded-b border-t bg-gray text-xs py-1 font-bold z-0">
                                <div class="mx-auto px-2" style="font-size: 10px;">
                                    {{ country.name }}
                                </div>
                                <div class="mx-auto px-2" style="font-size: 9px;">
                                    IPv4 {{ country.ipv4_total || 0 }} / IPv6 {{ country.ipv6_total || 0 }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <p class="text-[10px] text-center">HTTP & SOCKS5: {{ country.x_proxy }}</p>
                    <p class="text-[10px] text-center">HTTP & SOCKS5 /W VPN: {{ country.proxysmart }}</p> -->
                </div>
            </div>
        </div>
        <div class="text-[1rem] flex items-center py-1 px-3 bg-white gap-x-3 w-full">
            <p class="pr-4 text-[1.3rem]">IP Version</p>
            <div class="btn-group" role="group" aria-label="IP version">
                <button type="button" class="btn btn-sm" :class="ipVersion === 'ipv4' ? 'btn-primary' : 'btn-outline-primary'" @click="selectIpVersion('ipv4')">
                    IPv4
                </button>
                <button type="button" class="btn btn-sm" :class="ipVersion === 'ipv6' ? 'btn-primary' : 'btn-outline-primary'" @click="selectIpVersion('ipv6')">
                    IPv6
                </button>
            </div>
        </div>
        <div class="w-full flex flex-col lg:flex-row lg:items-center gap-2">
          <div v-if="ipVersion !== 'ipv6'" class="text-[1rem] flex items-center py-1 px-3 bg-white gap-x-3 w-full lg:w-1/2">
              <p class="pr-4 text-[1.3rem]">Need OS / IP Fingerprint Spoofing?</p>
              <div class="flex items-center">
                  <input v-model="fingerPrint"
                      type="radio" 
                      :value="true"
                      class="cursor-pointer"
                      name="fingerprint_yes" /> 
                  <label class="cursor-pointer p-2 peer-checked:bg-blue-500 peer-checked:text-white peer-checked:border-blue-500 transition">YES</label> 
              </div>
              <div class="flex items-center">
                  <input v-model="fingerPrint" 
                      type="radio" 
                      :value="false" 
                      class="cursor-pointer"
                      name="fingerprint_no" /> 
                  <label class="cursor-pointer p-2 peer-checked:bg-blue-500 peer-checked:text-white peer-checked:border-blue-500 transition">NO</label> 
              </div>
          </div>

          <div class="text-[1rem] flex items-center py-1 px-3 bg-white gap-x-3 w-full" :class="ipVersion === 'ipv6' ? 'lg:w-full' : 'lg:w-1/2'">
              <p class="pr-4 text-[1.3rem]">Need Socks UDP?</p>
              <div class="flex items-center">
                  <input v-model="socksUdp"
                      type="radio" 
                      :value="true"
                      class="cursor-pointer"
                      name="socks_udp_yes" /> 
                  <label class="cursor-pointer p-2 peer-checked:bg-blue-500 peer-checked:text-white peer-checked:border-blue-500 transition">YES</label> 
              </div>
              <div class="flex items-center">
                  <input v-model="socksUdp" 
                      type="radio" 
                      :value="false"
                      class="cursor-pointer"
                      name="socks_udp_no" /> 
                  <label class="cursor-pointer p-2 peer-checked:bg-blue-500 peer-checked:text-white peer-checked:border-blue-500 transition">NO</label> 
              </div>
          </div>
        </div>
        <div class="flex space-x-2 pb-4">
            <div class="w-1/2">
                <p class="font-bold py-2">ISP</p>
                <div class="overflow-hidden bg-white rounded-0 border-10 p-20">

                    <div v-for="isp in ispList" v-bind:key="isp" @click="selectedISP = isp.isp"
                        class="cursor-pointer float-left box-border" rounded="0">
                        <div class=" justify-between  items-center p-3 text-black">
                            <div class="relative rounded  shadow-md w-full  hover:scale-110  duration-500  border border-black"
                                :class="selectedDetails.isp === isp.isp ? 'scale-110 shadow-blue-500' : selectedDetails.isp ? 'opacity-50 ' : ''">
                                <img :src="isp?.isp_image ? backendUrl + isp?.isp_image : 'https://webcolours.ca/wp-content/uploads/2020/10/webcolours-unknown.png'"
                                    class="relative rounded-t object-cover" style="aspect-ratio: 1/1;" width="100"
                                    height="100">
                                <span
                                    class="position-absolute top-full start-100 translate-middle badge rounded-pill flex items-center justify-center aspect-square"
                                    :class="isp.proxy_count > 0 ? 'bg-success' : 'bg-danger'">
                                    {{ isp.proxy_count }}
                                </span>
                                <div
                                    class="w-full flex justify-between px-3 bottom-0 rounded-b  z-10 bg-gray text-xs py-1 font-bold">
                                    <div class="" style="font-size: 10px;">
                                        {{ isp.isp }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="font-bold py-2">City</p>
                <div class="bg-white p-20 lg:flex gap-x-4 flex-wrap">
                    <div v-for="city in cityList" v-bind:key="city" class=" w-full py-2 lg:w-fit flex justify-center">
                        <button type="button"
                            class="btn py-1 px-4 btn-primary rounded-full text-center relative hover:scale-110"
                            @click="selectCity(city.city, city.count, city.modem_id)"
                            :class="
                                selectedDetails.city === city.city && city.count !== 0 ?
                                'scale-110 shadow-blue-500 z-10' : selectedDetails.city === city.city && city.count === 0 ? 'scale-110 opacity-50' : city.count === 0 ? ' opacity-50 z-10 ' : ''"
                            style="font-size: 10px;">
                            <p>{{ city.city }}</p>
                            <span
                                class="position-absolute top-100 start-100 translate-middle badge rounded-pill flex items-center justify-center aspect-square z-10"
                                :class="city.count > 0 ? 'bg-success' : 'bg-danger'">
                                {{ city.count }}
                            </span>
                        </button>

                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <p class="font-bold py-2">Package</p>
                <div class="buy-package-panel p-4"
                    v-if="selectedDetails.country && selectedDetails.isp && selectedDetails.city && selectedDetails.modems_id.length > 0">
                    <!-- where, and how much is in stock, once above the plans -->
                    <div class="buy-package-head">
                        <span class="buy-package-head__title">Choose a package</span>
                        <span class="buy-package-head__where">
                            <v-icon icon="mdi-map-marker-outline" size="15"></v-icon>
                            {{ [selectedDetails.country, selectedDetails.city, selectedDetails.isp].filter(Boolean).join(' · ') }}
                            · <span :class="selectedCityCount > 0 ? 'text-ok' : 'text-warn'">{{ selectedCityCount > 0 ? `${selectedCityCount} in stock` : 'Out of stock' }}</span>
                        </span>
                    </div>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-6 pt-5">
                        <PackagePlanCard
                            v-for="option in packageOptions"
                            :key="option.key"
                            :plan="option.plan"
                            :period="option.key"
                            :selected="selectedPlan === option.key"
                            :daily-price="Number(plans.daily?.price) || 0"
                            :os-spoofing="fingerPrint"
                            :udp="socksUdp"
                            :disabled="selectedCityCount <= 0"
                            @select="selectedPlan = option.key"
                            @action="purchasePlan(option.key)"
                        />
                    </div>
                    <p v-if="admin && !adminCanBuy" class="buy-package-foot">
                        <v-icon icon="mdi-eye-outline" size="14"></v-icon>
                        This is exactly what customers see on Buy Proxy, filters included. Purchase opens the customer's purchase window as a preview; nothing is bought from here.
                    </p>
                    <p v-else-if="admin" class="buy-package-foot">
                        <v-icon icon="mdi-information-outline" size="14"></v-icon>
                        Purchase buys for the customer selected above, from their balance.
                    </p>

                    <button id="purchaseBtn" type="button" class="hidden" aria-hidden="true" tabindex="-1"
                        :disabled="!(selectedDetails.country && selectedDetails.isp && selectedDetails.city && selectedPlan && selectedCityCount > 0)"
                        data-bs-toggle="modal" data-bs-target="#purchaseModal">Purchase</button>
                </div>

            </div>
        </div>

    </div>
    <div>
        <AdminPurchaseModal v-if="admin && adminCanBuy"
            :selected-details="selectedDetails"
            :plan="selectedPlan && plans[selectedPlan]"
            :openVPN="openVPNTemp"
            :customer="customer"
            :needFingerPrint="fingerPrint"
            :needSocksUdp="socksUdp"
            @purchased="refreshStock"
        />
        <template v-else>
            <PurchaseModal :preview="admin" :selected-details="selectedDetails" :plan="selectedPlan && plans[selectedPlan]" :openVPN="openVPNTemp" />
            <NewLocationModal v-if="!admin" :selected-details="selectedDetails" />
            <NewStockModal v-if="!admin" :selected-details="selectedDetails" />
        </template>
    </div>
</template>

<script setup>

import { ref, watch, onMounted, nextTick, computed, defineProps } from "vue";
import { usePackageStore, useAdminConfigurationStore, useAdminPackageStore, useAlertStore } from "@/stores"
import { watchEffect } from "vue";
import { storeToRefs } from "pinia";
import PurchaseModal from "@/components/Customer/BuyNewProxy/PurchaseModal.vue"
import AdminPurchaseModal from "@/components/Admin/Proxy/Modals/PurchaseModal.vue"
import NewLocationModal from "@/components/Customer/BuyNewProxy/NewLocationModal.vue"
import NewStockModal from "@/components/Customer/BuyNewProxy/NewStockModal.vue"
import PackagePlanCard from "@/components/Common/PackagePlanCard.vue"

const props = defineProps({
    admin: { type: Boolean, default: false },   // rendered by the admin Proxy Stock page
});
const admin = computed(() => props.admin);
const name = process.env.VUE_APP_VUE_NAME;
// builds where an admin buys for a customer from Proxy Stock; on the others that page only shows the stock
const adminCanBuy = name === 'global' || name === 'proxygo';
const backendUrl = process.env.VUE_APP_VUE_SOCKET_URL + "/";
const ipVersion = ref('ipv4');
const selectedDetails = ref({ country: null, isp: null, city: null, modems_id: [], ip_version: ipVersion.value });
const adminConfigurationStore = useAdminConfigurationStore();
const packageStore = usePackageStore();
const { countryList, plans } = storeToRefs(packageStore);
const ispList = ref([]);
const cityList = ref([]);
const openVPNTemp = true;

const selectedISP = ref(null)
const selectedPlan = ref(null)

const fingerPrint = ref(false);
const socksUdp = ref(false);

// admin buying for a customer (Proxy Stock on the global / proxygo builds)
const customer = ref(null);
const customers = ref([]);
const CustomersWithBalance = ref([]);
if (props.admin && adminCanBuy) {
    const adminPackageStore = useAdminPackageStore();
    adminPackageStore.getCustomers();
    adminPackageStore.getCustomersWithBalance();
    const refs = storeToRefs(adminPackageStore);
    watchEffect(() => {
        customers.value = refs.customers.value || [];
        CustomersWithBalance.value = refs.CustomersWithBalance.value || [];
    });
}

const PLAN_ORDER = ['hourly', 'daily', 'weekly', 'monthly'];
const packageOptions = computed(() => PLAN_ORDER
    .map((key) => ({ key, plan: plans.value?.[key] }))
    .filter((option) => option.plan !== null && option.plan !== undefined));
const selectedCityCount = computed(() => Number(cityList.value.find((c) => c.city === selectedDetails.value.city)?.count || 0));

// a card's purchase button: select the plan, then open the purchase window
const purchasePlan = async (planKey) => {
    selectedPlan.value = planKey;
    if (props.admin && adminCanBuy && !customer.value) {
        useAlertStore().warning("Select a customer first");
        return;
    }
    await nextTick();
    document.getElementById("purchaseBtn")?.click();
};

// after an admin purchase: reload the stock and keep the country if it still has any
async function refreshStock() {
    const prevCountry = selectedDetails.value.country
    await packageStore.getCountryList(fingerPrint.value, socksUdp.value, ipVersion.value)
    ispList.value = []
    cityList.value = []
    selectedISP.value = null
    selectedPlan.value = null
    selectedDetails.value.isp = null
    selectedDetails.value.city = null
    selectedDetails.value.modems_id = []
    selectedDetails.value.ip_version = ipVersion.value
    const nextCountry =
        countryList.value?.find(c => c?.name === prevCountry)?.name ||
        countryList.value?.[0]?.name ||
        null
    selectedDetails.value.country = null
    await nextTick()
    selectedDetails.value.country = nextCountry
}
// No serverType filtering: always merge across XProxy + ProxySmart + IPROXY

const selectIpVersion = (version) => {
    if (version === 'ipv6') {
        fingerPrint.value = false;
    }
    ipVersion.value = version;
}

const countryAvailableTotal = (country) =>
    ipVersion.value === 'ipv6'
        ? Number(country?.ipv6_total || 0)
        : Number(country?.ipv4_total ?? (Number(country?.x_proxy || 0) + Number(country?.proxysmart || 0) + Number(country?.iproxy || 0) + Number(country?.proproxyui || 0)));

/** A city with stock lists the servers that have stock; a city with none lists all its servers, so its packages and
 *  prices still show (Out of stock), as on ProProxies. */
const normalizeCityModems = (cities) =>
    (cities || []).map((c) => ({
        ...c,
        modem_id: Array.isArray(c.modem_id) ? [...new Set(c.modem_id)] : [],
    }));

const fingerPrintClick = (val) => {
    fingerPrint.value = val;
}

const socksUdpClick = (val) => {
    socksUdp.value = val;
}

watchEffect(async () => {
    await adminConfigurationStore.getOpenvpn()
})

const { openvpn } = storeToRefs(adminConfigurationStore)

// No separate IPROXY option for No VPN; IPROXY will be merged into XProxy

const selectCountry = (countryName, proxy_count) => {
    // if (proxy_count > 0)
    selectedDetails.value.ip_version = ipVersion.value;
    if (selectedDetails.value.country === countryName) {
        selectedDetails.value.country = null
    }
    else {
        selectedDetails.value.country = countryName
    }
}

const selectCity = (cityName, proxy_count, modem_id) => {
    // if (proxy_count > 0)
    selectedDetails.value.city = cityName;
    selectedDetails.value.modems_id = modem_id;
    selectedDetails.value.ip_version = ipVersion.value;
}

onMounted(async () => {
    await packageStore.getCountryList(fingerPrint.value, socksUdp.value, ipVersion.value)
    selectedDetails.value.country = countryList.value[0]?.name
});
watchEffect(async () => {
    if (countryList.value?.length === 0){
        await packageStore.getCountryList(fingerPrint.value, socksUdp.value, ipVersion.value)
        // countryList.value[1] = countryList.value[0];
        // countryList.value[0] = temp;
        // [countryList.value[0], countryList.value[1]] = [countryList.value[1], countryList.value[0]]
        selectedDetails.value.country = countryList.value[0]?.name
    }

}, [countryList.value])
watch(
    () => selectedDetails.value.country,
    async (newCountry, oldCountry) => {
        if (newCountry) {
            // Always merge ISP lists across XProxy, ProxySmart, IPROXY, ProProxyUI (filtered by flags; IPv6: ProxySmart and ProProxyUI only)
            const xproxyISP = ipVersion.value === 'ipv6' ? [] : await packageStore.getISPList(newCountry, 'XProxy', fingerPrint.value, socksUdp.value, ipVersion.value);
            const iproxyISP = ipVersion.value === 'ipv6' ? [] : await packageStore.getISPList(newCountry, 'IPROXY', fingerPrint.value, socksUdp.value, ipVersion.value);
            const proxysmartISP = await packageStore.getISPList(newCountry, 'ProxySmart', fingerPrint.value, socksUdp.value, ipVersion.value);
            const proproxyuiISP = await packageStore.getISPList(newCountry, 'ProProxyUI', fingerPrint.value, socksUdp.value, ipVersion.value);

            const ispMap = new Map();
            const addISPList = (list) => {
                list?.forEach((item) => {
                    if (!item || !item.isp) return;
                    if (ipVersion.value === 'ipv6' && Number(item.proxy_count || 0) <= 0) return;
                    const key = item.isp;
                    const existing = ispMap.get(key) || {
                        isp: key,
                        proxy_count: 0,
                        isp_image: item.isp_image
                    };
                    existing.proxy_count += Number(item.proxy_count || 0);
                    if (!existing.isp_image && item.isp_image) {
                        existing.isp_image = item.isp_image;
                    }
                    ispMap.set(key, existing);
                });
            };
            addISPList(xproxyISP);
            addISPList(iproxyISP);
            addISPList(proxysmartISP);
            addISPList(proproxyuiISP);
            let ispListTemp = Array.from(ispMap.values());
            ispList.value = ispListTemp || [];

            if (ispList.value && ispList.value?.length > 0) {
                selectedDetails.value.isp = ispList.value[0].isp;
                selectedISP.value = ispList.value[0].isp;
            } else {
                selectedDetails.value.isp = null;
                selectedISP.value = null;
            }
        } else {
            ispList.value = [];
            cityList.value = [];
        }
    },
    { immediate: true }
);

watchEffect(async () => {
    if (selectedISP.value) {
        const tempISP = selectedISP.value
        selectedDetails.value.isp = tempISP
        if (selectedDetails.value.country && tempISP) {
            // Always merge cities from XProxy, ProxySmart, IPROXY and ProProxyUI for IPv4. IPv6: ProxySmart and ProProxyUI (ipv6 / dual ports).
            const baseCity = ipVersion.value === 'ipv6'
                ? []
                : await packageStore.getCityList(selectedDetails.value.country, tempISP, "XProxy", fingerPrint.value, socksUdp.value, ipVersion.value);
            cityList.value = normalizeCityModems(baseCity);

            const mergeTypes = ipVersion.value === 'ipv6' ? ["ProxySmart", "ProProxyUI"] : ["IPROXY", "ProxySmart", "ProProxyUI"];
            for (const type of mergeTypes) {
                const extraCity = await packageStore.getCityList(selectedDetails.value.country, tempISP, type, fingerPrint.value, socksUdp.value, ipVersion.value);
                const len = cityList.value?.length;
                extraCity?.map(city => {
                    if (len !== 0) {
                        let flag = 0;
                        for (let i = 0; i < cityList.value.length; i++) {
                            if (cityList.value[i].city.trim() === city.city.trim()) {
                                flag = 1;
                                const ids = Array.isArray(city?.modem_id) ? city.modem_id : [];
                                if (Number(city.count) > 0) {
                                    // stock here: only servers with stock (the out-of-stock ones listed so far drop out)
                                    if (Number(cityList.value[i].count) <= 0) cityList.value[i].modem_id = [];
                                    cityList.value[i].count = Number(cityList.value[i].count) + Number(city.count);
                                    ids.forEach((id) => cityList.value[i].modem_id.push(id));
                                } else if (Number(cityList.value[i].count) <= 0) {
                                    // no stock anywhere yet: keep every server, for the packages and prices
                                    ids.forEach((id) => cityList.value[i].modem_id.push(id));
                                }
                            }
                        }
                        if (flag === 0) {
                            cityList.value.push(city);
                        }
                    }
                    else {
                        cityList.value.push(city)
                    }
                });
            }
            cityList.value = normalizeCityModems(cityList.value);
            if (cityList.value && cityList.value?.length > 0){
                selectedDetails.value.city = cityList.value[0].city;
                selectedDetails.value.modems_id = cityList.value[0].modem_id
                selectedDetails.value.ip_version = ipVersion.value;
            }
            else {
                selectedDetails.value.city = null
            }
        }
    }
}, [selectedISP.value])

watch(
    () => [fingerPrint.value, socksUdp.value, ipVersion.value],
    async () => {
        const prevCountry = selectedDetails.value.country

        // Reload country list using current flags
        await packageStore.getCountryList(fingerPrint.value, socksUdp.value, ipVersion.value)

        // Reset dependent selections
        ispList.value = []
        cityList.value = []
        selectedISP.value = null
        selectedPlan.value = null
        selectedDetails.value.isp = null
        selectedDetails.value.city = null
        selectedDetails.value.modems_id = []
        selectedDetails.value.ip_version = ipVersion.value

        // Keep previous country if still available; otherwise pick first
        const nextCountry =
            countryList.value?.find(c => c?.name === prevCountry)?.name ||
            countryList.value?.[0]?.name ||
            null

        // Force re-trigger of the country watcher even if the country name didn't change
        selectedDetails.value.country = null
        await nextTick()
        selectedDetails.value.country = nextCountry
    }
)

watchEffect(() => {
    if (selectedDetails.value.country && selectedDetails.value.isp && selectedDetails.value.city && selectedDetails.value.modems_id.length > 0) {
        // emit("detailChoosed", selectedDetails.value)
        selectedDetails.value.ip_version = ipVersion.value;
        packageStore.getPlans(selectedDetails.value.country, selectedDetails.value.isp, selectedDetails.value.city, selectedDetails.value.modems_id, ipVersion.value).then((res) => {
            if (res){
                selectedPlan.value = Object.keys(res).filter(key => res[key] !== null)[0]
            }
        })
    }
}, [selectedDetails.value.city])


</script>

<style>
/* unscoped so body.dark reaches it (Vue's scoped :global() drops the rest of the selector);
   dark values are the site's own .dark .bg-white / .dark .card colours */
.buy-package-panel { background: #ffffff; border: 1px solid #d9dee5; border-radius: 12px; color: #1f2937; }
.buy-package-head { display: flex; flex-wrap: wrap; align-items: baseline; justify-content: space-between; gap: 6px 12px; }
.buy-package-head__title { font-size: 15px; font-weight: 600; }
.buy-package-head__where { font-size: 13px; color: #6b7280; display: inline-flex; flex-wrap: wrap; align-items: center; gap: 4px; }
.buy-package-head__where .text-ok { color: #198754; }
.buy-package-head__where .text-warn { color: #dc3545; }
.buy-package-foot { margin: 14px 0 0; font-size: 12.5px; color: #6b7280; display: flex; align-items: center; gap: 6px; }
body.dark .buy-package-panel { background: #34334a; border-color: #45445e; color: #ffffff; }
body.dark .buy-package-head__where, body.dark .buy-package-foot { color: #bcbbc7; }
body.dark .buy-package-head__where .text-ok { color: #4ade80; }
body.dark .buy-package-head__where .text-warn { color: #f87171; }
</style>
